import React, { useEffect, useState, useCallback } from "react";
import ReactDOM from "react-dom";

export default function Modal({
  isOpen,
  onClose,
  children,
  position = "center",
  maxWidth = "",
  closeOnBackdrop = true 
}) {
  const [showModal, setShowModal] = useState(isOpen);

  useEffect(() => {
    setShowModal(isOpen);
  }, [isOpen]);

  // Close handler must be declared before any effect that references it
  const handleClose = useCallback(() => {
    setShowModal(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300); // durata animazione
  }, [onClose]);

  // Blocca chiusura con ESC se richiesto
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && closeOnBackdrop) {
        handleClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [closeOnBackdrop, handleClose]);

  if (!isOpen && !showModal) return null;


  const overlayClasses =
    position === "center"
      ? "fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
      : "fixed inset-0 flex items-start justify-center pt-10 bg-gray-900 bg-opacity-50 z-50";

  const sizeClass = maxWidth ? `max-w-[${maxWidth}]` : "w-fit";

  const modalContent = (
    <div
      className={overlayClasses}
      onClick={(e) => {
        if (closeOnBackdrop && e.target === e.currentTarget) handleClose();
      }}
    >
      <div
        className={`transition-all duration-300 transform ${
          showModal ? "opacity-100 scale-100" : "opacity-0 scale-95"
        }  rounded-lg shadow-lg ${sizeClass} max-w-[calc(100vw-1rem)] max-h-[90vh] overflow-auto mx-2`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-gray-700">{children}</div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.getElementById("portal-root")
  );
}
